import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Faq = (props) => (
  <SvgIcon {...props} viewBox="0 0 26 26">
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="13" cy="13" r="12.5" stroke="currentColor" />
      <path
        d="M12.52 7.9C11.86 7.9 11.36 7.4 11.36 6.74C11.36 6.08 11.86 5.58 12.52 5.58C13.18 5.58 13.68 6.08 13.68 6.74C13.68 7.4 13.18 7.9 12.52 7.9ZM11.7 20V9.82H13.32V20H11.7Z"
        fill="currentColor"
      />
    </svg>
  </SvgIcon>
);
export default Faq;
